import axios from 'axios';
import { getAuthToken } from './authStorage';

// Never forward the application token to a signed storage URL.
export async function loadMapAsset(source, signal) {
  if (source instanceof Blob) return source;
  const url = new URL(source, axios.defaults.baseURL || window.location.origin);
  const api = new URL(axios.defaults.baseURL || window.location.origin);
  if (!['http:', 'https:', 'blob:'].includes(url.protocol)) throw new Error('The inspection needs a valid HTTP download URL for this file.');
  const response = await axios.get(url.href, {
    responseType: 'blob', signal,
    headers: { Authorization: url.origin === api.origin && url.protocol !== 'blob:' ? `Bearer ${getAuthToken()}` : null },
  });
  return response.data;
}
